// extracted by css-extract-rspack-plugin
export default {"root":"R0z1bo"};